module.exports = __webpack_public_path__ + "img/A_hdplan1.cb8f0f5a.png";